import GameList from '../../components/GameList'
import { useTheme } from '../../hooks/useTheme'

// styles
import './Games.css'

export default function Games() {
    const { mode } = useTheme()

    return (
        <div className={`layout ${mode}`}>
            <h1>My Games</h1>
            <p className="about">Come play some games I made! Games vary from a Memory Game to games made with Scratch.</p>
            <GameList />
        </div>
    )
}